<template>
    <VJoyTemplate full sidebar="right">
        <template #template-main>
            <VJoyTemplate full sidebar="left">
                <template #template-main>
                    <Content v-if="contentView?.content" :readonly="readonly" :content="contentView.content" type="privacy" human-id="privacy" />
                </template>
                <template #template-sidebar>
                    <Sidebar current-link="home" />
                </template>
            </VJoyTemplate>
        </template>
    </VJoyTemplate>
</template>
<script setup lang="ts">
    import {ref} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useAsyncData} from '#app';
    import {Content} from '#components';
    import {
        definePageMeta,
        useAuth,
        useTranslation,
        useSeoMeta,
        OpenGraphMetaTag,
        TwitterMetaTags,
        useOpenGraphMetaTags,
        useTwitterMetaTags,
    } from '#imports';
    import {VJoyTemplate} from '@maltjoy/core-vue';
    import {Configuration, PrivacyApiApi} from '@api';
    import Sidebar from '~/components/content/Sidebar.vue';

    const auth = useAuth();
    const {user, loggedIn} = storeToRefs(auth);
    const readonly = ref(!loggedIn.value || !user.value?.roles.includes('ROLE_ADMIN'));

    const {t} = useTranslation();

    const configuration = new Configuration({basePath: ''});
    const privacyApi = new PrivacyApiApi(configuration);

    const {data: contentView} = await useAsyncData(() => privacyApi.privacy(), {deep: true});

    useTwitterMetaTags(
        new TwitterMetaTags({
            card: 'summary',
            title: t('gdpr.title.privacy'),
            description: t('gdpr.meta.desc.privacy'),
            t,
        }),
    );
    useOpenGraphMetaTags(
        new OpenGraphMetaTag({
            title: t('gdpr.title.privacy'),
            description: t('gdpr.meta.desc.privacy'),
            t,
        }),
    );

    useSeoMeta({
        title: t('gdpr.title.privacy'),
        description: t('gdpr.meta.desc.privacy'),
    });

    definePageMeta({
        layout: 'content',
    });
</script>
